import { createRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';
import {
  Building2,
  Coins,
  FileCheck,
  FolderTree,
  Mail,
  MessageSquare,
  Tag,
} from 'lucide-react';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import CompanySettingsPage from '@/features/dashboard/companySettings/pages/CompanySettingsPage.tsx';
import { type ScreenTab } from '@/components/ui/TabScreen.tsx';

export enum SettingsTab {
  COMPANY = 'company',
  EMAIL_TEMPLATES = 'email-templates',
  SMS_TEMPLATES = 'sms-templates',
  CONSENT_TEMPLATES = 'consent-templates',
  COST_CATEGORIES = 'cost-categories',
  PAYMENT_CONFIG = 'payment-config',
  TAGS = 'tags',
}

export const SETTINGS_TABS: readonly ScreenTab<SettingsTab>[] = [
  {
    value: SettingsTab.COMPANY,
    label: 'Ogólne',
    icon: Building2,
    hint: 'nazwa, logo, prefiksy, waluta',
  },
  {
    value: SettingsTab.EMAIL_TEMPLATES,
    label: 'Szablony e-mail',
    icon: Mail,
    hint: 'wiadomości e-mail',
  },
  {
    value: SettingsTab.SMS_TEMPLATES,
    label: 'Szablony SMS',
    icon: MessageSquare,
    hint: 'krótkie powiadomienia',
  },
  {
    value: SettingsTab.CONSENT_TEMPLATES,
    label: 'Szablony zgód',
    icon: FileCheck,
    hint: 'wersjonowane',
  },
  {
    value: SettingsTab.COST_CATEGORIES,
    label: 'Kategorie kosztów',
    icon: FolderTree,
    hint: 'budżet wyjazdu',
  },
  {
    value: SettingsTab.PAYMENT_CONFIG,
    label: 'Płatności i waluty',
    icon: Coins,
    hint: 'konta, TPay, gotówka',
  },
  {
    value: SettingsTab.TAGS,
    label: 'Tagi',
    icon: Tag,
    hint: 'wspólne dla firmy',
  },
];

const searchSchema = z.object({
  /*
   * Brak zakładki to stan, nie błąd: na wąskim ekranie znaczy „menu”. Dlatego
   * nieznana wartość spada do `undefined`, a nie do pierwszej zakładki —
   * inaczej stary adres `?tab=message-templates` otwierałby Ogólne zamiast menu.
   */
  tab: z.enum(SettingsTab).optional().catch(undefined),
});

export const settingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/company-settings',
  component: CompanySettingsPage,
  validateSearch: searchSchema,
});
